import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_4bfffd30 from 'nuxt_plugin_plugin_4bfffd30' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_pluginsdynamic645e3005_eaa0bab6 from 'nuxt_plugin_pluginsdynamic645e3005_eaa0bab6' // Source: ./plugins.dynamic.645e3005.js (mode: 'all')
import nuxt_plugin_templatesplugind431ce70_6e3f3f8d from 'nuxt_plugin_templatesplugind431ce70_6e3f3f8d' // Source: ./templates.plugin.d431ce70.js (mode: 'all')
import nuxt_plugin_image_7c51257e from 'nuxt_plugin_image_7c51257e' // Source: ./image.js (mode: 'all')
import nuxt_plugin_pluginserver_6859d234 from 'nuxt_plugin_pluginserver_6859d234' // Source: ./nuxt-speedkit/plugin.server.js (mode: 'server')
import nuxt_plugin_pluginclient_02a060ac from 'nuxt_plugin_pluginclient_02a060ac' // Source: ./nuxt-speedkit/plugin.client.js (mode: 'client')
import nuxt_plugin_portalvue_63ebb7cd from 'nuxt_plugin_portalvue_63ebb7cd' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_gsapModule_694f58cb from 'nuxt_plugin_gsapModule_694f58cb' // Source: ./gsapModule.js (mode: 'all')
import nuxt_plugin_axios_525f1f74 from 'nuxt_plugin_axios_525f1f74' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_components_6fb0430c from 'nuxt_plugin_components_6fb0430c' // Source: ../plugins/components (mode: 'all')
import nuxt_plugin_getData_1e2dadcd from 'nuxt_plugin_getData_1e2dadcd' // Source: ../plugins/getData.js (mode: 'all')
import nuxt_plugin_isEmpty_baab066c from 'nuxt_plugin_isEmpty_baab066c' // Source: ../plugins/isEmpty.js (mode: 'all')
import nuxt_plugin_debounce_06d089d8 from 'nuxt_plugin_debounce_06d089d8' // Source: ../plugins/debounce.js (mode: 'all')
import nuxt_plugin_matchMedia_5d1eecc2 from 'nuxt_plugin_matchMedia_5d1eecc2' // Source: ../plugins/matchMedia.js (mode: 'all')
import nuxt_plugin_vClickOutside_77337246 from 'nuxt_plugin_vClickOutside_77337246' // Source: ../plugins/vClickOutside (mode: 'all')
import nuxt_plugin_vimeoPlayer_3017390f from 'nuxt_plugin_vimeoPlayer_3017390f' // Source: ../plugins/vimeoPlayer (mode: 'all')
import nuxt_plugin_mq_5d03b8cc from 'nuxt_plugin_mq_5d03b8cc' // Source: ../plugins/mq (mode: 'all')
import nuxt_plugin_filters_98405076 from 'nuxt_plugin_filters_98405076' // Source: ../plugins/filters (mode: 'all')
import nuxt_plugin_vTippy_33b9aff8 from 'nuxt_plugin_vTippy_33b9aff8' // Source: ../plugins/vTippy (mode: 'all')
import nuxt_plugin_hasContent_3c36b875 from 'nuxt_plugin_hasContent_3c36b875' // Source: ../plugins/hasContent (mode: 'all')
import nuxt_plugin_vMasonry_6a308a65 from 'nuxt_plugin_vMasonry_6a308a65' // Source: ../plugins/vMasonry (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"WELL for organizations","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"WELL Certified"},{"name":"format-detection","content":"telephone=no"}],"script":[{"src":"\u002F\u002Fjs.hsforms.net\u002Fforms\u002Fv2.js","type":"text\u002Fjavascript","charset":"utf-8","async":true},{"src":"https:\u002F\u002Fwww.eventbrite.com\u002Fstatic\u002Fwidgets\u002Feb_widgets.js","type":"text\u002Fjavascript","charset":"utf-8","async":true}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"preconnect","href":"https:\u002F\u002Fa.storyblok.com"},{"rel":"preconnect","href":"https:\u002F\u002Fapi.storyblok.com"},{"rel":"preconnect","href":"https:\u002F\u002Fforms.hsforms.com"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_4bfffd30 === 'function') {
    await nuxt_plugin_plugin_4bfffd30(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsdynamic645e3005_eaa0bab6 === 'function') {
    await nuxt_plugin_pluginsdynamic645e3005_eaa0bab6(app.context, inject)
  }

  if (typeof nuxt_plugin_templatesplugind431ce70_6e3f3f8d === 'function') {
    await nuxt_plugin_templatesplugind431ce70_6e3f3f8d(app.context, inject)
  }

  if (typeof nuxt_plugin_image_7c51257e === 'function') {
    await nuxt_plugin_image_7c51257e(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_6859d234 === 'function') {
    await nuxt_plugin_pluginserver_6859d234(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_02a060ac === 'function') {
    await nuxt_plugin_pluginclient_02a060ac(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_63ebb7cd === 'function') {
    await nuxt_plugin_portalvue_63ebb7cd(app.context, inject)
  }

  if (typeof nuxt_plugin_gsapModule_694f58cb === 'function') {
    await nuxt_plugin_gsapModule_694f58cb(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_525f1f74 === 'function') {
    await nuxt_plugin_axios_525f1f74(app.context, inject)
  }

  if (typeof nuxt_plugin_components_6fb0430c === 'function') {
    await nuxt_plugin_components_6fb0430c(app.context, inject)
  }

  if (typeof nuxt_plugin_getData_1e2dadcd === 'function') {
    await nuxt_plugin_getData_1e2dadcd(app.context, inject)
  }

  if (typeof nuxt_plugin_isEmpty_baab066c === 'function') {
    await nuxt_plugin_isEmpty_baab066c(app.context, inject)
  }

  if (typeof nuxt_plugin_debounce_06d089d8 === 'function') {
    await nuxt_plugin_debounce_06d089d8(app.context, inject)
  }

  if (typeof nuxt_plugin_matchMedia_5d1eecc2 === 'function') {
    await nuxt_plugin_matchMedia_5d1eecc2(app.context, inject)
  }

  if (typeof nuxt_plugin_vClickOutside_77337246 === 'function') {
    await nuxt_plugin_vClickOutside_77337246(app.context, inject)
  }

  if (typeof nuxt_plugin_vimeoPlayer_3017390f === 'function') {
    await nuxt_plugin_vimeoPlayer_3017390f(app.context, inject)
  }

  if (typeof nuxt_plugin_mq_5d03b8cc === 'function') {
    await nuxt_plugin_mq_5d03b8cc(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_98405076 === 'function') {
    await nuxt_plugin_filters_98405076(app.context, inject)
  }

  if (typeof nuxt_plugin_vTippy_33b9aff8 === 'function') {
    await nuxt_plugin_vTippy_33b9aff8(app.context, inject)
  }

  if (typeof nuxt_plugin_hasContent_3c36b875 === 'function') {
    await nuxt_plugin_hasContent_3c36b875(app.context, inject)
  }

  if (typeof nuxt_plugin_vMasonry_6a308a65 === 'function') {
    await nuxt_plugin_vMasonry_6a308a65(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
